/**
 * Legacy tapVibrate shim — delegates to the unified appFeedback system
 * so nav-bar taps still respect the user's Haptics toggle.
 * Prefer importing hapticTap / feedbackTap from ./appFeedback in new code.
 */
import { hapticTap } from './appFeedback';

export const tapVibrate = () => hapticTap();
